import { render, staticRenderFns } from "./ModulesWebForm.vue?vue&type=template&id=089fd39e&scoped=true"
import script from "./ModulesWebForm.vue?vue&type=script&lang=js"
export * from "./ModulesWebForm.vue?vue&type=script&lang=js"
import style0 from "./ModulesWebForm.vue?vue&type=style&index=0&id=089fd39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089fd39e",
  null
  
)

export default component.exports